import React from 'react';
import { QuizzicalContextProvider } from '../Context/QuizzicalContext';

export default function ContextCradle(props) {
    return (
        <QuizzicalContextProvider>
            {props.children}
        </QuizzicalContextProvider>
    );
}